import { twClassMerge } from '@healthhub/react-ui';
import type { ReactNode } from 'react';
import { memo } from 'react';


interface Props {
  children: ReactNode;
  className?: string;
  hidden?: boolean;
}

const RangeLabel = ({ children, className, hidden }: Props) => {
  if (hidden) return null;

  return <div className={twClassMerge('px-4 py-1 text-xs font-semibold rounded-3xl', className)}>{children}</div>;
};

export default memo(RangeLabel);
